window.addEventListener('load', (e) => {
  document.querySelectorAll('script[external_src]').forEach((script) => {
    const exSrc = script.getAttribute('external_src')
    script.setAttribute('src', exSrc)
    script.setAttribute('external_src', '')
  })
})
